module.exports = __webpack_public_path__ + "static/media/image2.09eec435.png";